// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-row-column-one',
    // #endregion
    // #region Properties
    props: {
        content: {
            type: Object,
            required: true,
            default: {}
        },
        row: {
            type: Object,
            required: true,
            default: {}
        },
        column: {
            type: Object,
            required: true,
            default: {}
        }
    },
    // #endregion
});
// #endregion
